<template>
    <div>
        <v-row >
            <v-col cols="12">
                <client-service-list :items="preparedClientServices"></client-service-list>
            </v-col>
        </v-row>
        <v-divider class="mt-3 mb-3"></v-divider>
        <v-row >
            <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                        v-model="selectedService"
                        :disabled="availableServicesForSelector.length === 0"
                        :items="availableServicesForSelector || []"
                        @change="handleSelectService"
                        item-text="fullTitle"
                        item-value="id"
                        no-data-text="No available services"
                        label="Select service for add it to current client"
                        clearable
                        return-object
                >
                    <template
                            slot="selection"
                            slot-scope="data"
                    >
                        <v-chip
                                class="chip--select-multi v-chip--small"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                        {{ data.item.code }}
                                    </span>
                                </template>
                                {{ data.item.title }}
                            </v-tooltip>
                        </v-chip>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row v-if="selectedService" >
            <v-col cols="12" sm="6" md="6">
                <v-form v-model="addServiceFormValid">
                    <div>
                        <p class="text-no-wrap">
                            Add service <b>{{selectedService.title}}</b> to "{{client.title}}".
                        </p>
                    </div>
                    <v-text-field
                            v-model="price"
                            label="Price for client"
                            :rules="priceRules"
                            required
                    ></v-text-field>

                    <div class="text-right">
                        <v-btn small
                               :disabled="progress('addServiceToClient')"
                               @click="handleCancelAddServiceToClientButtonClick">
                            Cancel
                        </v-btn>
                        <v-btn color="success"
                               small
                               :loading="progress('addServiceToClient')"
                               :disabled="!addServiceToClientButtonActive"
                               @click="handleAddServiceToClientButtonClick">
                            Add service to client
                        </v-btn>
                    </div>
                </v-form>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {isNumeric} from '../../../helpers/numbers'
    import {mapActions, mapGetters, mapState} from 'vuex'
    import ClientServiceList from '../Components/ClientServiceList'

    export default {
        name: "ClientServices",
        props: {
            client: Object
        },
        components: {
            ClientServiceList
        },
        data() {
            return {
                price: null,
                selectedService: null,
                addServiceFormValid: null,
                priceRules: [
                    v => !!v || 'Enter service base price',
                    function (v) {
                        return isNumeric(v) || 'Value must be numeric'
                    },
                    function (v) {
                        return isNumeric(v) && parseFloat(v) > 0.0 || "Value must be positive"
                    }
                ],
            }
        },
        created() {
            this.fetchClientServicesIfNeeded(this.client.id)
        },
        computed: {
            ...mapState('services', {
                services: 'services',
                servicesById: 'servicesById',
                clientServicesByClientId: 'clientServicesByClientId'
            }),
            ...mapGetters('services', {
                progress: 'progress'
            }),
            availableServicesForSelector() {
                const clientServicesByServiceId = _.get(this.clientServicesByClientId, this.client.id, {})

                let result = []

                for (let service of this.services) {
                    if (clientServicesByServiceId[service.id]) {
                        continue
                    }

                    result.push(service)
                }
                return result
            },
            addServiceToClientButtonActive() {
                return this.addServiceFormValid && !this.progress('addServiceToClient')
            },
            preparedClientServices() {
                const clientServicesByServiceId = _.get(this.clientServicesByClientId, this.client.id, {})

                let result = []


                for (let service of this.services) {
                    if (!clientServicesByServiceId[service.id]) {
                        continue
                    }

                    const clientService = clientServicesByServiceId[service.id]

                    result.push({
                        id: clientService.id,
                        title: service.title,
                        code: service.code,
                        serviceId: clientService.serviceId,
                        clientId: clientService.clientId,
                        fullTitle: service.fullTitle,
                        price: clientService.price,
                        currency: clientService.currency
                    })
                }
                return result
            }
        },
        methods: {
            ...mapActions('services', {
                fetchClientServicesIfNeeded: 'fetchClientServicesIfNeeded',
                addServiceToClient: 'addServiceToClient'
            }),
            handleCancelAddServiceToClientButtonClick() {
                this.reset()
            },
            async handleAddServiceToClientButtonClick() {
                try {
                    await this.addServiceToClient({
                        clientId: this.client.id,
                        serviceId: this.selectedService.id,
                        price: this.price,
                    })
                } catch (e) {
                    console.log(`Unable to add service to client`)
                }
                this.reset()
            },
            handleSelectService(service) {
                if (!service) {
                    this.reset()
                    return
                }

                this.price = service.price
            },
            reset() {
                this.price = null
                this.selectedService = null
            }

        }
    }
</script>

<style scoped>

</style>